/**
 * Littlemore Accordion Custom Element
 *
 * Usage:
 *   <littlemore-accordion data-allow-multiple>
 *     <div data-accordion-item>
 *       <button data-accordion-trigger aria-expanded="false">Title</button>
 *       <div data-accordion-content>Content</div>
 *     </div>
 *   </littlemore-accordion>
 */
class LittlemoreAccordion extends HTMLElement {
  constructor() {
    super();
    this.items = [];
  }

  connectedCallback() {
    this.allowMultiple = this.hasAttribute('data-allow-multiple');
    this.items = this.querySelectorAll('[data-accordion-item]');

    this.items.forEach((item) => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      if (!trigger) return;

      const content = item.querySelector('[data-accordion-content]');
      if (!content) return;

      content.style.overflow = 'hidden';
      content.style.transition = 'max-height var(--transition-slow, 300ms ease)';

      if (trigger.getAttribute('aria-expanded') !== 'true') {
        content.style.maxHeight = '0';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      trigger.addEventListener('click', () => this.toggle(item));
    });
  }

  toggle(targetItem) {
    const trigger = targetItem.querySelector('[data-accordion-trigger]');
    const content = targetItem.querySelector('[data-accordion-content]');
    if (!trigger || !content) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    if (!this.allowMultiple && !isOpen) {
      this.items.forEach((item) => {
        if (item !== targetItem) this.close(item);
      });
    }

    if (isOpen) {
      this.close(targetItem);
    } else {
      this.open(targetItem);
    }
  }

  open(item) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const content = item.querySelector('[data-accordion-content]');
    if (!trigger || !content) return;

    trigger.setAttribute('aria-expanded', 'true');
    content.style.maxHeight = content.scrollHeight + 'px';
    item.classList.add('is-open');
  }

  close(item) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const content = item.querySelector('[data-accordion-content]');
    if (!trigger || !content) return;

    trigger.setAttribute('aria-expanded', 'false');
    content.style.maxHeight = '0';
    item.classList.remove('is-open');
  }
}

customElements.define('littlemore-accordion', LittlemoreAccordion);
